{
  "exd-storyteller-ai/firefly": "/firefly",
  "exd-storyteller-ai/photoshop": "/ps",
  "exd-storyteller-ai/ccLibrariesProxy": "/express",
  "exd-storyteller-ai/stories": "/stories",
  "exd-storyteller-ai/videos": "/videos",
  "exd-storyteller-ai/templates": "/templates",
  "exd-storyteller-ai/zoltar": "/zoltar",
  "exd-storyteller-ai/generatePresentation": "/express/generate",
  "exd-storyteller-ai/uploadFileToS3": "/s3",
  "exd-storyteller-ai/zoltarDemoPilot": "/zoltar-demo-pilot",
  "exd-storyteller-ai/fluffyjaws": "/fluffyjaws",
  "exd-storyteller-ai/linkChecker": "/linkchecker",
  "exd-storyteller-ai/downloads": "/downloads",
  "exd-storyteller-ai/ffmpeg": "/ffmpeg",
  "exd-storyteller-ai/jobs": "/jobs",
  "exd-storyteller-ai/mogrt": "/mogrt",
  "exd-storyteller-ai/ims": "/ims",
  "exd-storyteller-ai/admin": "/admin",
  "exd-storyteller-ai/aurora": "/aurora",
  "exd-storyteller-ai/footage": "/footage",
  "exd-storyteller-ai/feedback": "/feedback",
  "exd-storyteller-ai/alerts": "/alerts"
}
